<template>
  <div>
    <b-card no-body>
      <b-card-header class="d-flex align-items-center justify-content-between">
        <b-card-title>
          {{ dataItem.title }}
        </b-card-title>
        <b-card-sub-title>
          Proje Kodu: {{ dataItem.pcode }}
        </b-card-sub-title>
      </b-card-header>
      <b-card-body>
        <div class="mb-1 border-bottom pb-1">
          <div class="font-weight-bold font-medium-1">
            Departman
          </div>
          <div>{{ dataItem.department }}</div>
        </div>
        <div class="mb-1 border-bottom pb-1">
          <div class="font-weight-bold font-medium-1">
            Ekip
          </div>
          <div>{{ dataItem.team }}</div>
        </div>
        <div class="mb-1 border-bottom pb-1">
          <div class="font-weight-bold font-medium-1">
            Açıklamalar
          </div>
          <div>
            <div v-html="dataItem.description" />
          </div>
        </div>
        <div class="mb-1">
          <div class="font-weight-bold font-medium-1">
            Notlar
          </div>
          <div>
            {{ dataItem.notes }}
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BCardTitle, BCardHeader, BCardSubTitle,
} from 'bootstrap-vue'

export default {
  name: 'ProjectCard',
  components: {
    BCardSubTitle,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('projects/getDataItem', this.$route.params.id)
    },
  },
}
</script>
